import React from 'react'
import { AccountContainer } from '../../AccountContainer'
import { ConversationList } from './ConversationList'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  return (
    <AccountContainer>
      <PageTitle title="My Messages" description="View and manage your conversations and messages" />
      <ConversationList />
    </AccountContainer>
  )
}
